import { Fragment, ReactNode, useEffect, useState } from 'react';
import '../../style/carousel.css';

import { News } from '@/src/data/types';
import { EmblaOptionsType } from 'embla-carousel';
import { Link } from 'react-router-dom';
import '../../style/CardSlide.css';
import Card from '../3DCarousel/Card';
import Carousel from '../3DCarousel/Carousel';
import { Button } from '../ui/button';
import { getAllNews } from '../../API/News/newsService';

import img1 from '../../images/news/10.jpg';
import img2 from '../../images/news/IMG_E6696.jpg';
import img3 from '../../images/news/VALSE-DES-CARPES_001.jpg';
import img4 from '../../images/news/aqua-3771946_1920-170x116.jpg';
import img5 from '../../images/news/teamwork-3213924_1920.jpg';
type Props = {
  children?: ReactNode;
};

const OPTIONS: EmblaOptionsType = { loop: true };
const SLIDE_COUNT = 5;
const SLIDES = Array.from(Array(SLIDE_COUNT).keys());
const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

const newsData = [
  {
    id: 2,
    title: 'Philippe LEROY est nommé Directeur Général des Services d’AQUAVESC et HYDREAULYS',
    pic: img1,
    desc: 'C’est avec grand plaisir que nous accueillons l’arrivée de Philippe LEROY au poste de Directeur Général des Services pour Eaux Seine Ouest, nos deux établissements publics territoriaux : AQUAVESC et HYDREAULYS.',
  },
  {
    id: 3,
    title: "La qualité d'eau potale",
    pic: img4,
    desc: "La qualité d'eau potale est ",
  },
  {
    id: 1,
    title: 'Exercice de crise',
    pic: img5,
    desc: 'AQUAVESC a eu le plaisir de participer, en fin de semaine dernière, à un exercice de crise sur le territoire régional, impliquant d’autres acteurs de l’eau. Ainsi, le syndicat mais également SÉNÉO, SEDIF et la Ville de Paris se sont coordonnés autour d’une coupure de courant initié par RTE qui avait pour conséquence, entre autres, la pollution de la Marne entraînant la fermeture de 2 usines de distribution d’eau potable.',
  },
  {
    id: 4,
    title: 'Les lauréats ECOL’EAU PRO !',
    pic: img2,
    desc: 'Avec la période de crise sanitaire qui a déstabilisé financièrement certains professionnels et fragilisé leur activité, AQUAVESC s’est engagé aux côtés des pouvoirs publics et des collectivités territoriales à soutenir le plan de relance et à favoriser les actions éco-responsables.',
  },
  {
    id: 5,
    title: 'AQUAVESC – Carpe Diem !',
    pic: img3,
    desc: 'À l’occasion des travaux de curage des bassins d’eau brute de l’usine de Louveciennes, une journée a été organisée afin de transférer les carpes du bassin Sud vers le bassin Nord. Ainsi, les équipes de SEOP, d’AQUAVESC ainsi que des élus du comité AQUAVESC ont eu le plaisir de participer, samedi 3 septembre 2022, à cette “valse des carpes”, en mettant la main (ou plutôt l’épuisette) à la pâte.',
  },
];

const NewsHomeSection = (props: Props) => {
  const [news, setNews] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllNews();
    setNews(response?.news);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const cards =
    news &&
    news
      .filter(item => !item.isDraft)
      .map((item, index) => ({
        key: index,
        content: (
          <Card
            key={item.id}
            img={`${uploadUrl}/news/${item.image}`}
            title={item.title}
            desc={item.description}
            slug={item.slug}
          />
        ),
      }));

  // const cards =
  //   newsData &&
  //   newsData.map((item, index) => {
  //     return {
  //       key: index,
  //       content: (
  //         <Card
  //           key={item.id}
  //           title={item.title}
  //           img={item.pic}
  //           desc={item.desc}
  //         />
  //       ),
  //     };
  //   });

  return (
    <Fragment>
      <div
        className="p-4 md:p-24 "
        style={{
          zIndex: 0,
        }}
      >
        <div className="text-3xl font-bold text-center text-black">Actualités</div>
        <div className="container">
          <div className="flex justify-center mt-10">
            {/* <EmblaCarousel cardContentData={cardContentData} options={OPTIONS} />   */}
          </div>
          {/* <NewsSwiper /> */}

          <Carousel
            cards={cards}
            height="500px"
            width="80%"
            margin="0 auto"
            offset={2}
            showArrows={false}
          />
        </div>
      </div>
      <div className="flex justify-center ">
        <Link to="/actualités">
          <Button className="bg-aquaFoncé">Voir toutes les actualités</Button>
        </Link>
      </div>
    </Fragment>
  );
};

export default NewsHomeSection;
